export const getBreadcrumbItem = (status, hostRequester, t) => {
  if (status === 'Diproses') {
    return [
      {
        title: `${t('title')} - ${t('tabRequested')}`,
        href: '/schedule/approval-reschedule?tab=requested',
      },
      {
        title: hostRequester,
      },
    ];
  }
  return [
    {
      title: `${t('title')} - ${t('tabDone')}`,
      href: '/schedule/approval-reschedule?tab=done',
    },
    {
      title: hostRequester,
    },
  ];
};